import React, { useState, useEffect } from "react";
import SectionWrapper, {
    Container
} from './hairPatch.style';

import Fade from 'react-reveal/Fade';

const HairPatch = () => {

      const [featuresData, setFeaturesData] = useState(null);
    
      useEffect(() => {
        // const apiUrl = process.env.GATSBY_API_URL;
        // console.log("Using API URL:", apiUrl); // Debugging
      
        fetch(`https://radianceadmin.manageprojects.in/api/product-features`)
          .then(response => response.json())
          .then(data => {
            if (data.success) {
              setFeaturesData(data.data[0]);
            }
          })
          .catch(error => console.error("Error fetching data:", error));
      }, []);
      
      if (!featuresData) return <div></div>;

    return (
        <SectionWrapper id="counters">
            <Container className='myContainer flexDirecColumn px-3'>
                {/* <Fade bottom><h2 style={{ color: '#000', marginBottom: '20px', textAlign: 'center' }}>Hair Patch in Delhi for Mens and Women</h2></Fade>
                <Fade bottom>
                    <div className="achivment">
                        <p>Hair patches have become a widely preferred and highly effective solution for individuals facing hair loss in Delhi. This non-surgical approach provides an instant transformation, offering a natural-looking, fuller head of hair without resorting to invasive procedures like hair transplants. Crafted from premium-quality synthetic or natural hair, <a href="/hair-patch-mens.php"> hair patch in Delhi </a> are tailored to match each individual's unique hair texture, color, and density.
                        </p>
                        <p>Radiance Hair Clinic stands out as a top provider of high-quality hair patches in Delhi, recognized for its exceptional products and superior customer care. Numerous clients have regained their confidence through the clinics personalized hair patch solutions. 
                        </p>
                    </div>
                </Fade> */}
                <Fade bottom>
                  <div className="text-center" dangerouslySetInnerHTML={{ __html: featuresData.content_description }} />
                  </Fade>
            </Container>
        </SectionWrapper>
    );
};

export default HairPatch;
